<script lang="ts">
  import {
    mdiTrashCanOutline,
    mdiCheck,
    mdiPlus,
    mdiSwapHorizontal,
    mdiMinusCircleOutline,
  } from "@mdi/js"
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxActionToggleCell from "../../../../../../_shared/_modules/inbox-action-toggle-cell"
  import type {
    ContactPointDecision,
    ContactPointReviewDraft,
    ContactPointReviewRow,
  } from "../../contract"

  let props: InboxWorkflowCellProps<ContactPointReviewRow, ContactPointReviewDraft> = $props()

  const hasExistingContactValue = $derived(Boolean(props.row.existingContactValue.trim()))
  const options = $derived(
    props.row.reviewKind === "delete_contact_point"
      ? [
          { value: "delete", label: "Löschen", icon: mdiTrashCanOutline, tone: "danger" as const },
          { value: "reject", label: "Beibehalten", icon: mdiCheck, tone: "neutral" as const },
        ]
      : [
          { value: "append", label: "Ergänzen", icon: mdiPlus },
          ...(hasExistingContactValue
            ? [{ value: "replace", label: "Ersetzen", icon: mdiSwapHorizontal }]
            : []),
          {
            value: "reject",
            label: "Ignorieren",
            icon: mdiMinusCircleOutline,
            tone: "neutral" as const,
          },
        ],
  )
</script>

<InboxActionToggleCell
  value={props.draft.action}
  {options}
  disabled={props.binding.disabled}
  ariaLabel={`Kontaktdaten-Entscheidung für ${props.row.customerLabel}`}
  wrap={true}
  allowEmptySelection={true}
  onChange={(next) => props.patchDraft({ action: next as ContactPointDecision })}
/>
